import { render, staticRenderFns } from "./PermissionsView.vue?vue&type=template&id=17d603a6&"
import script from "./PermissionsView.vue?vue&type=script&lang=js&"
export * from "./PermissionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d603a6')) {
      api.createRecord('17d603a6', component.options)
    } else {
      api.reload('17d603a6', component.options)
    }
    module.hot.accept("./PermissionsView.vue?vue&type=template&id=17d603a6&", function () {
      api.rerender('17d603a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/PermissionsView.vue"
export default component.exports